import React from 'react';
import { MunicipalityBreadCrumb } from '../../../components/MunicipalityBreadCrumb';
import { useParams } from 'react-router-dom';

/**
 * @param {object} params
 * @param {{label: string, url?: string}[]} params.extraItems
 */
export const MemberBreadCrumb = ({ extraItems }) => {
    const { municipalityId, bodyType } = useParams();

    const items = [];

    if (municipalityId) {
        items.push({
            label: bodyType
        })
        items.push({
            label: 'Členové',
            url: `/admin/municipality/${municipalityId}/${bodyType}/clenove`
        });
    }

    if (extraItems) {
        items.push(...extraItems);
    }

    return <MunicipalityBreadCrumb extraItems={items} />;
};
